import { render, staticRenderFns } from "./FileUploadQ.vue?vue&type=template&id=72f4889b&scoped=true&"
import script from "./FileUploadQ.vue?vue&type=script&lang=js&"
export * from "./FileUploadQ.vue?vue&type=script&lang=js&"
import style0 from "./FileUploadQ.vue?vue&type=style&index=0&id=72f4889b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f4889b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VInput } from 'vuetify/lib/components/VInput';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VFlex,VIcon,VInput,VLayout})
